import { differenceInDays } from 'date-fns';
import { getLocalStorage, setLocalStorage } from '@/services/localStorage';
import { PaginationProps } from '@/trio-ui/Pagination/Pagination.component';
import { LocalStorageItemKeys, ValuesWithLabel } from '@/types';
import { fieldsAndFriendlyLabelsList, sortByGroupOptions } from './JobsList.constants';

export type PaginationData = Omit<
  PaginationProps,
  'onChangeRecordsPerPage' | 'onChangePageHandler' | 'hideItemsPerPageDropdown'
>;

export const setPaginationDataToLocalStorage = (newPaginationData: PaginationData): void => {
  setLocalStorage(LocalStorageItemKeys.JOBS_TABLE_PAGINATION, JSON.stringify(newPaginationData));
};

export const getPaginationDataFromLocalStorage = (): PaginationData | null => {
  const paginationData = getLocalStorage(LocalStorageItemKeys.JOBS_TABLE_PAGINATION);

  if (paginationData) {
    const parsedPaginationData = JSON.parse(paginationData);
    return parsedPaginationData;
  }

  return null;
};

export const getDaysDistanceFromDate = (date: string): [string, number] => {
  const numberedDifference = differenceInDays(new Date(), new Date(date));
  let formatedLabel = '';

  if (numberedDifference > 0) {
    const isPlural = numberedDifference > 1;
    formatedLabel = `${numberedDifference} day${isPlural ? 's' : ''} ago`;
  } else {
    formatedLabel = 'Today';
  }

  return [formatedLabel, numberedDifference];
};

export const getSortByOptions = (): ValuesWithLabel[] => {
  const formatSortByOptions = ([value, label]: string[]): ValuesWithLabel => ({ value, label });
  const isFieldOnSortOptions = ([key]: string[]): boolean => sortByGroupOptions.includes(key);

  const sortByOptionsFiltered = fieldsAndFriendlyLabelsList.filter(isFieldOnSortOptions);
  const sortByOptionsFormatted = sortByOptionsFiltered.map(formatSortByOptions);

  return sortByOptionsFormatted;
};

export const getFormatedCurrency = (amount: number): string =>
  new Intl.NumberFormat('en-US').format(amount);

export const getFormattedCurrencyOriginalValue = (formattedAmount: string): number =>
  Number(formattedAmount.slice(1).trim().replaceAll(',', ''));
